import { FunctionComponent, useCallback, useEffect, useState } from 'react';
import {
	SideMenu, AppBarTop, IconButton, Dropdown, DropdownOption, ContextMenu,
	Divider,
	ContextMenuItem,
	Switch,
	SystemIcon,
	SearchField,
	NotificationBadge,
	Avatar,
	Typography
} from '@volvo/vcdk-react';
import { shoppingCartMenuItem } from '../../MenuConfig';
import { useNavigate } from 'react-router-dom';
import i18next from 'i18next';
import { TranslationLanguage, languages as languagesList } from '../../../Translation/translationConfig';
import { useTranslation } from 'react-i18next';
import { useMsal } from '@azure/msal-react';
import { selectThemeId, toggleTheme } from '../../store/NavigationBarSlice';
import { useAppDispatch, useAppSelector } from '../../../../store/Hooks';

export const HeaderSection: FunctionComponent = () => {
	const [referenceElement, setReferenceElement] = useState<HTMLElement | null>(
		null,
	);
	const { instance } = useMsal();

	const navigate = useNavigate();
	const languages: TranslationLanguage[] = [...languagesList];
	const currentLanguage = i18next.resolvedLanguage;
	const { t } = useTranslation('navigation');
	const themeId = useAppSelector(selectThemeId);
	const dispatch = useAppDispatch();

	const onSelectLanguage = (language: string) => {
		if (language !== currentLanguage) {
			i18next.changeLanguage(language);
		}
	};

	const onToggleSideMenu = useCallback(() => {
		document.querySelector<any>(".side-menu")?.toggle();
	}, []);

	const onSignOut = useCallback(() => {
		instance.logoutRedirect()
	}, [instance]);


	const onClickToggleTheme = () => dispatch(toggleTheme(themeId.endsWith('-dark') ? "volvo-light" : "volvo-dark"));

	return (
		<>
			<AppBarTop className="volvo-app-bar-top" serviceName={t('menu.title')}>
				
				<IconButton className="menu-hamburger" icon="hamburger-menu" onClick={onToggleSideMenu} slot="start"/>
				
				<SearchField placeholder="Search" aria-label="Search" icon="search" autocomplete="off" size="small" slot="end" style={{ width: 328 }} />

				<NotificationBadge invisible={false} content={"5"} slot="end">
					<SystemIcon icon="user" size={24}></SystemIcon>
				</NotificationBadge>

				<IconButton	icon="question-mark" ref={(ref: any) => setReferenceElement(ref)} slot="end" />

				<IconButton slot="end" icon="leaf" filled={true} />
				
				<Typography variant="caption1" style={{ borderLeft: '1px solid var(--vcdk-color-border)', paddingLeft: 16, gap: 8 }} slot='end'>Bruce Wayne</Typography>

				<Avatar imageUrl="/assets/images/avatar.jpg" text="Bruce Wayne" slot="end" />
				
			</AppBarTop>

			<ContextMenu
				reference={referenceElement}
				referenceType="anchor"
				placement="bottom-end">
				<Dropdown
					label="Language"
					size="small"
					value={currentLanguage}
					style={{ margin: 12 }}
					onChange={(e: Event) => onSelectLanguage((e as CustomEvent).detail.value)}>
					{languages.map(language => (
						<DropdownOption key={language.key} value={language.key}>
							{t(language.label as unknown as TemplateStringsArray)}
						</DropdownOption>
					))}
				</Dropdown>
				<Divider />

				<div style={{ margin: 12, display: "flex", gap: 8 }}>
					<SystemIcon icon="sun" />
					<Switch checked={themeId.endsWith("-dark")} onClick={onClickToggleTheme} />
					<SystemIcon icon="moon" />
				</div>

				<Divider />
				<ContextMenuItem icon="logout" onClick={onSignOut}>
					Sign out
				</ContextMenuItem>
			</ContextMenu>
		</>
	);
};
